const faqItems = [
  {
    id: 1,
    question: '黑料网站是什么？和普通娱乐新闻有什么区别？',
    answer: '黑料网站是一个专注于网红娱乐圈非主流信息聚合的导航平台。与普通娱乐新闻不同，我们汇集吃瓜黑料网站、51黑料网站、91黑料网站等来源，聚焦明星八卦、网红翻车、娱乐圈内幕等"吃瓜"向内容，为用户提供一站式黑料网站大全，帮助快速定位真实爆料而非官方通稿。',
  },
  {
    id: 2,
    question: '51黑料网站和91黑料网站有什么区别？哪个更值得看？',
    answer: '51黑料网站以明星八卦和综艺内幕见长，内容更新频率极高；91黑料网站则侧重网红翻车和直播带货领域的爆料，深度分析更多。两者各有侧重，建议搭配浏览。本站黑料网站推荐合集会根据内容质量和更新频率进行标注，帮助你根据兴趣选择。',
  },
  {
    id: 3,
    question: '网站内容多久更新一次？会不会错过最新大瓜？',
    answer: '本站作为黑料网站大全导航，每日实时监控多个吃瓜黑料网站的最新动态，话题榜单和快讯时间线每小时刷新。热门话题区标注了内容热度，你可以一眼看出哪些是当前最火的爆料，不必担心错过任何重要大瓜。',
  },
  {
    id: 4,
    question: '如何判断爆料内容的真实性？有没有假消息？',
    answer: '我们收录的网红黑料网站推荐均经过来源筛选，优先展示有多次可靠记录的优质来源。同时热度标签会反映内容的讨论量和多方验证情况——热度越高的爆料通常经过越多的交叉验证。但网络信息错综复杂，建议理性吃瓜，多方比对。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950">
            常见问答
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            关于黑料网站，你想知道的都在这里
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {faqItems.map((item, index) => (
            <details
              key={item.id}
              className="bg-background-50 rounded-xl border border-background-200/70 group"
              open={index === 0}
            >
              <summary className="flex items-center justify-between p-5 md:p-6 cursor-pointer list-none">
                <h3 className="text-base md:text-lg font-semibold text-foreground-900 pr-4">
                  {item.question}
                </h3>
                <span className="w-7 h-7 flex items-center justify-center shrink-0 rounded-full bg-primary-100 text-primary-500 group-open:rotate-45 transition-transform duration-300">
                  <i className="ri-add-line"></i>
                </span>
              </summary>
              <div className="px-5 md:px-6 pb-5 md:pb-6">
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}